export class AlleleConstants {
    public static RestAllele: string = "X";
}